import { CoreInitiativesFilesByIdName } from './name';
import { coreInitiativesFilesRemoveSyncSlice } from '../remove';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativeFile } from '@api';

export const coreInitiativesFilesByIdDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesFilesRemoveSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesFilesByIdName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativeFile
});
